import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const AutosuggestPopupItemSkeleton = ({ index }) => {
  return (
    <div
      className="col-4 col-sm-3 col-md-2 col-lg-2 search-results mt-3"
      key={1000 + index}
    >
      <div className="cc-serach-result">
        <div className="product-list search-product-list">
          <div className="product-items search-product-items">
            <Skeleton height={80} width={80} />
          </div>
          <div className="product-details mt-2">
            <h6 className="product-title">
              <Skeleton width={100} />
              <Skeleton width={80} />
            </h6>
            <div className="product-price">
              <Skeleton width={50} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
